import styled from 'styled-components'
import { Colors } from '../../../colors'

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`

export const Item = styled.li`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: ${Colors.GS300};
  }
`
